import { baseEmailAssets, baseEmailTheme, TenantInfo } from '../common';
import { tos } from './tos';

export const tenant = {
  id: 'demo',
  name: 'Pelicargo Demo',
  isSystemTenant: false,
  domains: ['localhost', 'local.env', 'demo.pelicargo.dev', 'pelicargo.com', 'demo.pelicargo.com'],
  customerTheme: {
    colors: {
      primary: {
        '50': '#FFF7E5',
        '100': '#FEEECB',
        '200': '#FDD997',
        '300': '#F9BC63',
        '400': '#F4A03D',
        '500': '#ED7500',
        '600': '#CB5A00',
        '700': '#AA4200',
        '800': '#892F00',
        '900': '#712100',
      },
    },
    logoDims: {
      height: 19,
      width: 194,
    },
    fullLogoDims: {
      height: 19,
      width: 194,
    },
  },
  emailTheme: baseEmailTheme,
  emailAssets: {
    ...baseEmailAssets,
    logo: 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-symbol.png',
    'logo-dark': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-dark.png',
    'logo-light': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-symbol.png',
    'logo-dark-tagline': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-dark.png',
    'logo-light-tagline': 'https://raw.githubusercontent.com/pelicargo/assets/master/logo-light.png',
    twitterUrl: 'https://twitter.com/pelicargo/',
    facebookUrl: 'https://www.facebook.com/pelicargo/',
    linkedinUrl: 'https://www.linkedin.com/company/pelicargo/',
    siteUrl: 'https://www.pelicargo.com',
  },
  admin: {
    cruds: {
      accounts: true,
      providers: false,
      airports: false,
      contacts: true,
      instructions: false,
      users: true,
      backlogs: false,
      surcharges: false,
      rates: false,
      'route-editor': false,
      configuration: false,
    },
    inbox: {
      requestDrawers: {
        // Provider Facing
        ProviderQuoting: true,
        AirlineBooking: true,
        RequestSchedule: true,
        BookingChange: true,
        BookingCancel: true,

        // Customer Facing
        QuoteUpdate: true,
        BookingConfirmation: true,
        NewRate: true,
        RequestClarifications: true,
        Contact: true,
        GenericEmailToFF: true,
        StatusUpdate: true,
      },
    },
    features: {
      instructionCreation: true,
    },
  },
  accountTypes: {
    IATA: true,
    IAC: true,
    ORGANIZATION: true,
    UNCERTIFIED: true,
  },
  customer: {
    supportChat: true,
  },
  termsOfService: tos,
} as const satisfies TenantInfo<'demo'>;
